import { SwapManagementAction } from './swap-managerment-action';
import { link } from 'react-icons-kit/fa/link';
import { cloudUpload } from 'react-icons-kit/fa/cloudUpload';
import { cloudDownload } from 'react-icons-kit/fa/cloudDownload';
import { user_remove } from 'react-icons-kit/ikons/user_remove';
import { people } from 'react-icons-kit/iconic/people';
import { userTimes } from 'react-icons-kit/fa/userTimes';
import { user_add } from 'react-icons-kit/ikons/user_add';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { ISwapManagementPosition } from './swap-management-position';

interface IProps {
    data: ISwapManagementPosition,
    isLastPosition: boolean,
    action: number,
    currentIndex: number,
    onAction: (action: SwapManagementAction, index: number) => void
}

const SwapManagementRow = (props: IProps) => {
    const handleAction = (action: SwapManagementAction) => {
        props.onAction(action, props.data.index);
    };

    let showReplacePair = false;
    let showReplaceRecipient = false;

    if (props.isLastPosition && props.data.positionNumber > 1) {
        if (props.data.recipient.id == -1) {
            showReplacePair = true;
        } else {
            showReplaceRecipient = true;
        }
    }

    if (props.isLastPosition && props.data.positionNumber == 1 && props.data.recipient.id != -1) {
        showReplaceRecipient = true;
    }

    const buttons = [
        { action: SwapManagementAction.Unbridge, title: 'Relink/unbridge Donor', icon: cloudUpload, show: props.data.positionNumber == 1 && props.data.clusterNumber != 1 },
        { action: SwapManagementAction.Bridge, title: 'Bridge Donor', icon: cloudDownload, show: (props.data.positionNumber == 1 && props.data.clusterNumber != 1) == false && props.data.positionNumber > 1 },
        { action: SwapManagementAction.NewChainAsVoucher, title: 'Start New Chain as Voucher', icon: link, show: props.data.clusterNumber > 1 || props.data.positionNumber > 1 },
        { action: SwapManagementAction.RemoveRecipient, title: 'Remove Recipient', icon: user_remove, show: props.isLastPosition && props.data.recipient.id != -1 },
        { action: SwapManagementAction.RemovePair, title: 'Remove Pair', icon: userTimes, show: props.data.positionNumber > 1 && props.isLastPosition && props.data.recipient.id == -1 },
        { action: SwapManagementAction.ReplacePair, title: 'Replace Pair', icon: people, show: showReplacePair },
        { action: SwapManagementAction.ReplaceRecipient, title: 'Replace Recipient', icon: people, show: showReplaceRecipient },
        { action: SwapManagementAction.AddRecipient, title: 'Add Recipient', icon: user_add, show: props.data.recipient.id == -1 }
    ];

    const buttonsToShow = buttons.filter(x => x.show);

    const currentAction = buttons.find(x => x.action == props.action && props.data.index == props.currentIndex);

    return (
        <tr className={props.data.highlightRow ? 'highlight' : null}>
            <td title={'ClusterId=' + props.data.clusterId}>
                {props.data.chainId} / {props.data.clusterNumber} / {props.data.positionNumber}
            </td>
            <td className={props.data.highlightDonor ? 'highlight' : null}>
                {props.data.donor.center.alias}
                {props.data.donor.rdnCenterAlias != '' && (
                    <>&nbsp;(<span style={{ fontSize: 12, color: 'red' }}>{props.data.donor.rdnCenterAlias})</span></>
                )}
            </td>
            <td className={props.data.highlightDonor ? 'highlight' : null}>
                <a href={`/center/${props.data.donor.centerId}/donor/${props.data.donor.id}/profile`} target='_blank'>{props.data.donor.alias}</a>
            </td>
            <td>&raquo;</td>
            <td className={props.data.highlightRecipient ? 'highlight' : null}>
                {props.data.recipient.id != -1 ? props.data.recipient.center.alias : '--'}
            </td>
            <td className={props.data.highlightRecipient ? 'highlight' : null}>
                {props.data.recipient.id != -1 ?
                    <a href={`/center/${props.data.recipient.centerId}/recipient/${props.data.recipient.id}/profile/general`} target='_blank'>{props.data.recipient.alias}</a>
                    :
                    <>--</>
                }
            </td>
            <td style={{ display: 'flex', justifyContent: 'center' }}>
                {buttonsToShow.length > 0 && (
                    <DropdownButton title={currentAction != null ? currentAction.title : 'Actions'} id='swap-actions' bsSize='xs' bsStyle='primary'>
                        {buttonsToShow.map((button, index) =>
                            <MenuItem key={'swp-action-' + index} eventKey={button.action} onClick={() => handleAction(button.action)}>{button.title}</MenuItem>
                        )}
                    </DropdownButton>
                )}
            </td>
        </tr>
    );
}

export default SwapManagementRow;